<template>
  <vs-row v-if="campaign !== null" class="page-header">
    <div class="vx-col w-full">
      <vx-card :noShadow="true">
        <div class="vx-row insights-header-container">
          <div class="vx-col md:text-left sm:w-full md:w-1/5 md:pl-4">
            <h6 class="text-normal font-normal text-gray-600 text-opacity-75">{{ $t('Campaign Name') }}</h6>
            <vx-tooltip :text="campaign.name">
              <p class="md:mt-3 cursor-pointer font-semibold text-lg insights-campaign-name">
                {{ campaign.name }}
              </p>
            </vx-tooltip>
          </div>

          <div class="vx-col md:text-left sm:w-full md:w-1/5 md:pl-16">
            <h6 class="text-normal font-normal text-gray-600 text-opacity-75">{{ $t('Start/End Date') }}</h6>
            <p class="md:mt-3 font-semibold text-lg insights-date">
              {{ campaign.start_date === null ? $t('Once it\'s approved') : campaign.start_date }} / {{ campaign.end_date === null ? $t('No End Date') : campaign.end_date }}
            </p>
          </div>

          <div class="campagin-insights-status-mobile-version vx-col md:text-left sm:w-full md:w-1/5 md:pl-16">
            <h6 class="text-normal font-normal text-gray-600 text-opacity-75">{{ $t('Status') }}</h6>
            <p class="sm:mt-3 font-semibold text-lg insights-status">
              <span :class="{'text-green-600': aggregated_status.status == 'Delivering', 'text-red-600': aggregated_status.status == 'Not Delivering'}">
                {{ aggregated_status.status }}
              </span>
              <span v-if="campaign.tags.map(e => e.name.en).includes('premium')">
                <vs-icon icon-pack="speakol" icon="speakol-premium-solid" class="star-solid-icon" style="font-size: 15px !important;"></vs-icon>
              </span>
               <br>
              <span class="font-normal" v-if="aggregated_status.reason !== ''">
                {{ aggregated_status.reason }}
              </span>
            </p>
          </div>

          <div class="spent-parent vx-col md:text-left sm:w-full md:w-1/5 md:pl-16">
            <h6 class="text-normal font-normal text-gray-600 text-opacity-75">{{ $t('Spent') }}</h6>
            <p class="spent-value sm:mt-3 font-semibold text-lg insights-spent">
              {{ campaign.analytics.spent | addComma('$') }}
            </p>
          </div>

          <div
            v-bind:class="[ campaign.start_date === null && campaign.end_date === null ? 'no_start_date_no_end_date' : '' , (campaign.start_date != null && campaign.end_date != null) || (campaign.start_date === null && campaign.end_date != null) || (campaign.start_date != null && campaign.end_date === null) ? 'start_date_and_end_date' : ''  ]"
            class="vx-col md:text-left sm:w-full md:w-1/5  action-parent"
          >
            <vx-tooltip class="insights-tooltip" v-if="campaign.activation_status == 1" text="Pause" position="top">
              <button id="page-header-paused-button" class="pause-icon" @click="changeCampaignStatus('Paused')">
                <img src="@/assets/images/actions/pause.svg" />
              </button>
            </vx-tooltip>
            <vx-tooltip class="insights-tooltip" v-else text="Resume" position="top">
              <button id="page-header-active-button" class="play-icon" @click="changeCampaignStatus('Active')">
                <img src="@/assets/images/actions/activate.svg" />
              </button>
            </vx-tooltip>

            <vx-tooltip v-bind:class="{ tracking_mobile_version : currentRouteName === 'campaigns-insights' || currentRouteName === 'campaigns-edit' }" class="insights-tooltip" text="View Tracking" position="top">
              <router-link id="page-header-tracking-button" v-if="showActionX(ACTIONS.TRACKING)" class="track-icon" :to="{ name: 'conversions', query: { id: this.campaign.id } }">
                <img class="" src="@/assets/images/actions/tracking.svg" alt="">
              </router-link>
            </vx-tooltip>

            <vx-tooltip v-bind:class="{ insights_mobile_version : currentRouteName === 'campaigns-tracking' }" class="insights-tooltip" text="View Insights" position="top">
              <router-link id="page-header-insights-button" v-if="showActionX(ACTIONS.INSIGHTS)" class="insights-icon" :to="{ name: 'campaigns-insights', params: { id: $route.params.id } }">
                <img class="align-middle pl-3" src="@/assets/images/actions/view.svg" />
              </router-link>
            </vx-tooltip>

            <vx-tooltip class="edit-tooltip insights-tooltip" text="Edit" position="top">
              <router-link id="page-header-edit-button" v-if="showActionX(ACTIONS.EDIT)" class="edit-icon" :to="{ name: 'campaigns-edit', params: { id: $route.params.id }, }">
                <img src="@/assets/images/actions/edit.svg" alt="">
              </router-link>
            </vx-tooltip>
            <div v-if="$can('edit_premium_campaigns') && $hasFeature('premium-campaigns')">
            <vx-tooltip class="premium-tooltip" v-if="campaign.tags.map(e => e.name.en).includes('premium')" text="Change to Standard Campaign" position="top">
              <button id="page-header-premium-button" class="premium-icon" @click="toggleConfirmationPopup()">
                <vs-icon icon-pack="speakol" icon="speakol-premium" class="" style="color: #ffbb07; font-size: 22px !important;"></vs-icon>
              </button>
            </vx-tooltip>
            <vx-tooltip class="premium-tooltip" v-else text="Feature as Premium Campaign" position="top">
              <button id="page-header-standard-button" class="premium-icon" @click="toggleConfirmationPopup()">
                 <vs-icon icon-pack="speakol" icon="speakol-premium-solid" class="" style="color: #ffbb07; font-size: 22px !important;"></vs-icon>
              </button>
            </vx-tooltip>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
      <SpeakolNotificationToaster
          :show="isToasterVisible"
          :message="toasterText"
          :icon="saveIcon"
          closeButtonText="X"
          @close="isToasterVisible = false"
        />

      <speakol-confirmation-popup
      v-on:hide-confirmation-popup="showBlockConfirmationPopup = false"
      v-on:confirm="changeCampaignPremiumStatus()"
      :showConfirmationPopup="showBlockConfirmationPopup"
      :title="`${campaign.tags.map(e => e.name.en).includes('premium') ? 'Change to Standard Campaign' : 'Upgrade to Premium'}`"
      :htmlBody ="confirmationPopupBody"
    />
  </vs-row>
</template>

<script>
import SpeakolNotificationToaster from '@/components/SpeakolNotificationToaster'

export default {
  components: {
    SpeakolNotificationToaster
  },
  props: {
    displayable_links: {
      type: Array,
      required: false,
      default: () => [], // campaign_insights, campaign_edit, campaign_tracking,
      validator (values) {
        for (let i = 0; i < values.length; i++) {
          const value = values[i]
          const exists = ['campaign_insights', 'campaign_edit', 'campaign_tracking'].includes(value)
          if (!exists) {
            return false
          }
        }
        return true
      }
    }
  },
  data () {
    return {
      showBlockConfirmationPopup:false,
      confirmationPopupBody : '',
      saveIcon: require('@/assets/images/success.svg'),
      isToasterVisible: false,
      toasterText: '',
      campaign: null,
      statusMeta: {
        'Delivering': {
          nameIcon: require('@/assets/images/campaign-status/active-name-icon.svg'),
          statusIcon: require('@/assets/images/campaign-status/active-status-icon.svg'),
          actionIcon: require('@/assets/images/campaign-status/active-action-icon.svg'),
          displayName: this.$t('Delivering')
        },
        'Not Delivering': {
          nameIcon: require('@/assets/images/campaign-status/rejected-name-icon.svg'),
          statusIcon: null,
          actionIcon: null,
          displayName: this.$t('No Serving Adsets')
        },
        'Not Delivering: Paused': {
          nameIcon: require('@/assets/images/campaign-status/paused-name-icon.svg'),
          statusIcon: require('@/assets/images/campaign-status/paused-status-icon.svg'),
          actionIcon: require('@/assets/images/campaign-status/paused-action-icon.svg'),
          displayName: this.$t('Paused')
        },
        'Not Delivering: Out Of Budget': {
          nameIcon: require('@/assets/images/campaign-status/out-of-budget-name-icon.svg'),
          statusIcon: require('@/assets/images/campaign-status/out-of-budget-status-icon.svg'),
          actionIcon: require('@/assets/images/campaign-status/out-of-budget-action-icon.svg'),
          displayName: this.$t('Not Delivering: Out Of Budget')
        },
        'Not Delivering: Scheduled': {
          nameIcon: require('@/assets/images/campaign-status/scheduled-name-icon.svg'),
          statusIcon: require('@/assets/images/campaign-status/scheduled-status-icon.svg'),
          actionIcon: require('@/assets/images/campaign-status/scheduled-action-icon.svg'),
          displayName: this.$t('Not Delivering: Scheduled')
        },
        'Not Delivering: Completed': {
          nameIcon: require('@/assets/images/campaign-status/is-completed-name-icon.svg'),
          statusIcon: require('@/assets/images/campaign-status/is-completed-status-icon.svg'),
          actionIcon: require('@/assets/images/campaign-status/is-completed-action-icon.svg'),
          displayName: this.$t('Completed')
        },
        // fallback status
        'N/A': {
          nameIcon: require('@/assets/images/campaign-status/out-of-budget-name-icon.svg'),
          statusIcon: require('@/assets/images/campaign-status/out-of-budget-status-icon.svg'),
          actionIcon: require('@/assets/images/campaign-status/out-of-budget-action-icon.svg'),
          displayName: this.$t('N/A')
        }
      },
      ACTIONS: {
        TRACKING: 'tracking',
        INSIGHTS: 'insights',
        EDIT: 'edit'
      }
    }
  },
  computed: {
    statusKey () {
      if (this.$store.getters['fund/balance']['balance'] <= 0) {
        return 'Not Delivering: Out Of Budget'
      }

      return Object.keys(this.statusMeta).includes(this.campaign.aggregated_status) ? this.campaign.aggregated_status : 'N/A'
    },
    currentRouteName () {
      return this.$route.name
    },
    aggregated_status () {
      return this.campaign ? this.campaign.aggregated_status : {}
    }
  },
  async created () {
    await this.getCampaign()

    this.$root.$on('campaign-adsets-or-ads-status-updated', () => {
      this.getCampaign()
    })

    this.$root.$on('displayable-status-updated', (aggregated_status) => {
      this.campaign.aggregated_status = aggregated_status
    })
  },
  methods: {
    showActionX (action) {
      if (action === this.ACTIONS.TRACKING) {
        return this.campaign.objective_id !== this.$constants.CAMPAIGN_OBJECTIVES_IDS.LEAD_FORM &&
          this.$can('campaign_tracking') &&
          this.displayable_links.includes('campaign_tracking')
      } else if (action === this.ACTIONS.INSIGHTS) {
        return this.$can('campaign_insights') && this.displayable_links.includes('campaign_insights')
      } else if (action === this.ACTIONS.EDIT) {
        return this.$canAny('edit_personal_campaigns', 'edit_all_campaigns') && this.displayable_links.includes('campaign_edit')
      }

      return false
    },
    toggleConfirmationPopup () {
      const campaignName = this.trimString(this.campaign.name, 20).bold()
      if (this.campaign.tags.map(e => e.name.en).includes('premium')) {
        this.confirmationPopupBody = `Are you sure you want to ${campaignName} into a standard campaign?`
      } else {
        this.confirmationPopupBody = `Are you sure you want to feature ${campaignName} as a premium campaign?`
      }
      this.showBlockConfirmationPopup = true
    },
    showToaster () {
      this.isToasterVisible = true
      setTimeout(() => {
        this.isToasterVisible = false
      }, 5000)
    },
    changeToasterText (text) {
      this.toasterText = text
    },
    async changeCampaignPremiumStatus () {
      let status = true
      if (this.campaign.tags.map(e => e.name.en).includes('premium')) {
        status = false
      }
      await window.axios.post('/campaigns/toggle/premium/status', {
        premium_status: status,
        campaign_id : this.campaign.id
      }).then((response) => {
        if (response.status === 200 && response.data.payload) {
          this.campaign.tags = response.data.payload
          if (this.campaign.tags.map(e => e.name.en).includes('premium')) {
            this.changeToasterText(`${this.trimString(this.campaign.name, 20)  } will be displayed as a Premium Campaign.`)
          } else {
            this.changeToasterText(`${this.trimString(this.campaign.name, 20)   } will be displayed as a Standard Campaign.`)
          }
          this.showBlockConfirmationPopup = false
          this.showToaster()
        }
      })
    },
    trimString (string, length) {
      return string.length > length ? `${string.substring(0, length)  }...` : string
    },
    async getCampaign () {
      const response = await window.axios.get(`/campaigns/${this.$route.params.id}/insights`)

      this.campaign = response.data.payload
    },
    setCampaignActivationStatus ({ activation_status, camapign_aggregated_status }) {
      this.campaign.activation_status = activation_status
      this.campaign.aggregated_status = camapign_aggregated_status
    },
    /**
     * Change campaign status
     * Note: campaigns statuses are stored as enum in the Campaign.php model
     */
    async changeCampaignStatus (status) {
      try {


        const response = await window.axios.post(`/campaigns/${this.$route.params.id}/update-activation-status`, {
          status,
          _method: 'PATCH'
        })

        this.campaign.activation_status = response.data.payload.activation_status
        this.campaign.aggregated_status = response.data.payload.camapign_aggregated_status

        this.$root.$emit('changed:campaign-status')


      } catch (error) {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-header::v-deep {
  .star-solid-icon {
    color: #ffbb07;
    position: relative;
    top: 3px;
    left: 5px;
  }

  .insights-header-container {
    div:not(:last-of-type) {
      border-right: 1px solid rgba(0, 0, 0, 0.25);
    }

    @media (max-width: 576px) {
      div:not(:last-of-type) {
        border-right: none;
        border-bottom: none;
      }

      p {
        margin-bottom: 20px;
      }

      .campagin-insights-status-mobile-version {
        width: 100%;
      }

      .insights-campaign-name {
        width: 250px;
        overflow-wrap: break-word;
      }
    }
  }

  .insights-campaign-name {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .page-header-parnet {
    text-align: center;
  }

  .pause-now-button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    color: #e02020;
    font-size: 1.125rem;
    border-right: 1px solid rgba(0, 0, 0, 0.25);
    padding-right: 15px;
  }

  .pause-icon {
    background-color: rgba(219, 40, 40, 0.15);
    border: none;
    padding: 10px;
    padding-bottom: 8px;
    cursor: pointer;
    border-radius: 100%;
    margin-right: 10px;
  }

  .premium-icon {
    background-color: #fdf5e1;
    outline: 0;
    border: 0;
    box-shadow: 0;
    padding: 10px 14px 10px 13px;
    cursor: pointer;
    border-radius: 100%;
  }

  .play-icon {
    background-color: rgba(33, 186, 69, 0.15);
    border: none;
    padding: 10px;
    padding-bottom: 8px;
    cursor: pointer;
    border-radius: 100%;
    margin-right: 10px;
  }

  .track-icon {
    background-color: rgba(0, 146, 215, 0.15);
    border: none;
    padding: 12px 11px 13px 10px;
    cursor: pointer;
    border-radius: 100%;
    position: relative;
    top: 3px;
    margin-right: 10px;

    img {
      position: relative;
      top: 7px;
      right: 0;
    }
  }

  .edit-icon {
    background-color: rgba(0, 146, 215, 0.15);
    border: none;
    padding: 12px 15px 13px 12px;
    cursor: pointer;
    border-radius: 100%;
    position: relative;
    top: 6px;

    img {
      position: relative;
      top: 5px;
      right: -2px;
      width: 20px;
    }
  }

  .insights-icon {
    background-color: rgba(0, 146, 215, 0.15);
    border-radius: 100%;
    padding: 15px 5px 10px 10px;
    position: relative;
    top: 15px;
    margin-right: 10px;

    img {
      position: relative;
      left: -7px;
      top: -3px;
    }
  }

  .no_start_date_no_end_date {
    position: relative;
    top: 25px;
    display: flex;
  }

  .start_date_and_end_date {
    position: relative;
    top: 15px;
    display: flex;
  }

  .insights-tooltip {
    border-right: none !important;
  }

  @media (max-width: 576px) {
    .no_start_date_no_end_date,
    .start_date_and_end_date {
      padding-bottom: 30px !important;
    }

    .spent-parent {
      width: 100%;
    }

    .action-parent {
      margin: 0 auto;
      margin-top: 10px;
    }

    .spent-value {
      margin-bottom: 0 !important;
    }

    .insights-campaign-name,
    .insights-date,
    .insights-status,
    .insights-spent {
      margin-top: 10px;
    }

    .tracking_mobile_version,
    .insights_mobile_version {
      margin-left: 20px;
      margin-right: 20px;
    }

    .premium-tooltip {
      margin-left: 20px;
    }

    .export-fixed-popup {
      width: 345px;;
    }
  }

  @media (min-width: 1740px) {
    .action-parent {
      position: relative;
      top: 3px;
      left: 28px;
    }
  }
}
</style>
